<script setup>
const props = defineProps({
  video: String,
});
</script>

<template>
  <div v-if="video" class="px-md lg:px-lg xl:px-xl mb-xl last:mb-0">
    <video autoplay loop muted playsinline class="w-full">
      <source :src="video" type="video/mp4" />
    </video>
  </div>
</template>

<style></style>
